"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseKeycloakIssuerUri = parseKeycloakIssuerUri;
var toFullyQualifiedUrl_1 = require("./toFullyQualifiedUrl");
/**
 * Return undefined if the issuerUri doesn't match the expected shape of a Keycloak issuerUri
 *
 * Example:
 *
 * `parseKeycloakIssuerUri("https://auth.my-company.com/auth/realms/myrealm")` returns:
 * {
 *    origin: "https://auth.my-company.com",
 *    realm: "myrealm",
 *    kcHttpRelativePath: "/auth",
 *    adminConsoleUrl: "https://auth.my-company.com/auth/admin/myrealm/console",
 *    getAccountUrl: ({ thisAppDisplayName, backToAppFromAccountUrl }) =>
 *        `https://auth.my-company.com/auth/realms/myrealm/account?referrer=${thisAppDisplayName}&referrer_uri=${backToAppFromAccountUrl}`
 * }
 * */
function parseKeycloakIssuerUri(issuerUri) {
    var url = new URL(issuerUri);
    var split = url.pathname.split("/realms/");
    if (split.length !== 2) {
        return undefined;
    }
    var _a = __read(split, 2), kcHttpRelativePath = _a[0], realm = _a[1];
    return {
        origin: url.origin,
        realm: realm,
        kcHttpRelativePath: kcHttpRelativePath === "" ? undefined : kcHttpRelativePath,
        adminConsoleUrl: "".concat(url.origin).concat(kcHttpRelativePath, "/admin/").concat(realm, "/console"),
        getAccountUrl: function (_a) {
            var clientId = _a.clientId, backToAppFromAccountUrl = _a.backToAppFromAccountUrl, locale = _a.locale;
            var accountUrlObj = new URL("".concat(url.origin).concat(kcHttpRelativePath, "/realms/").concat(realm, "/account"));
            accountUrlObj.searchParams.set("referrer", clientId);
            accountUrlObj.searchParams.set("referrer_uri", (0, toFullyQualifiedUrl_1.toFullyQualifiedUrl)({
                urlish: backToAppFromAccountUrl,
                doAssertNoQueryParams: false
            }));
            if (locale !== undefined) {
                accountUrlObj.searchParams.set("kc_locale", locale);
            }
            return accountUrlObj.href;
        }
    };
}
//# sourceMappingURL=parseKeycloakIssuerUri.js.map